import { http, HttpResponse } from 'msw';

import { toggles } from './fixtures/toggle';
import { svgImg } from './fixtures/img-placeholder';

export const coreHandlers = [
  http.get('**/toggle', () => HttpResponse.json({ toggles })),

  // OTHERS
  http.get('https://placehold.co/*', () => HttpResponse.xml(svgImg)),
];
